// Returns yesterday's date as a local-time `YYYY-MM-DD` string.
// Used as the default From/To landing value across report pages
// (Grooming, Random Attendance, Task Response) — most users open these
// the morning after to review the previous day's data.
export const getLocalYesterdayDateString = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const yyyy = String(d.getFullYear());
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

// Formats an ISO/date string as a short `DD Mon YYYY` Indian-locale date
// (e.g. "21 Jun 2026"). Shared by the LMS pages (Journeys, Module
// Assignments, Content) which all render created/updated timestamps the
// same way.
export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Formats a calendar day ('2026-06-17', or a timestamp starting with one) as
// "17 Jun 2026", reading the digits off the string. Unlike `formatDate`, no Date
// is built, so a browser outside IST cannot shift a date-only value to the day
// before. Anything that is not a day is echoed back unchanged. Shared by the
// Employees page's Inactive tab and the Sales & Targets screens.
export const formatIsoDay = (iso: string): string => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m || !MONTH_ABBR[Number(m[2]) - 1]) return iso;
  return `${Number(m[3])} ${MONTH_ABBR[Number(m[2]) - 1]} ${m[1]}`;
};

// Formats an ISO/date string as a locale date+time via `toLocaleString()`,
// rendering an em-dash for null/undefined and echoing the raw input if the
// Date constructor throws. Shared verbatim by the Task Response list and the
// Custom Report panel, which both display created/last-run timestamps.
export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
};
